import { useState } from 'react';

import PropTypes from 'prop-types';

import FieldWithEditable from './FieldWithEditable';

import { FieldContainerStyled } from './styles';

// When click edit button, it will show children as edit view
export default function ReadOrEdit({
  title,
  value,
  children,
  onEditHandler,
  onTrackingEvent,
  customStyle
}) {
  const [isEditing, setIsEditing] = useState(false);

  const onEdit = () => {
    if (typeof onTrackingEvent === 'function') {
      onTrackingEvent();
    }
    if (typeof onEditHandler === 'function') {
      onEditHandler(true);
    }
    setIsEditing(true);
  };

  return (
    <FieldContainerStyled sx={customStyle}>
      {isEditing ? (
        children
      ) : (
        <FieldWithEditable
          onEdit={onEditHandler ? onEdit : null}
          title={title}
          value={value}
        />
      )}
    </FieldContainerStyled>
  );
}

ReadOrEdit.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onEditHandler: PropTypes.func,
  onTrackingEvent: PropTypes.func,
  customStyle: PropTypes.shape({})
};
